/**
 * Token 存储（与 web 项目一致，便于同源登录态共用）
 */
const TOKEN_KEY = 'auth_token';

export function saveToken(token) {
  if (token) {
    sessionStorage.setItem(TOKEN_KEY, token);
  }
}

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function clearToken() {
  sessionStorage.removeItem(TOKEN_KEY);
}
